<template>
  <v-row dense justify="center" align="center">
    <v-col cols="12" sm="6">
      <v-expansion-panels outlined v-model="panel_open">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="primary"> $expand </v-icon>
            </template>
            <template>
              <v-row no-gutters align="center">
                <v-col cols="8">
                  <v-row dense no-gutters align="center">
                    <v-col cols="auto">
                      <v-icon color="black" size="25" class="mr-1"
                        >mdi-face-agent</v-icon
                      >
                    </v-col>
                    <v-col cols="9">
                      <strong>
                        {{ $t("messanger.dash.filters.agents.header") }}
                      </strong>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row justify="center">
              <v-col cols="12">
                <v-form
                  v-model="valid"
                  @submit.prevent="saveItem"
                  enctype="multipart/form-data"
                >
                  <v-sheet elevation="0" outlined rounded="xl">
                    <v-sheet
                      class="pa-3 text-center"
                      color="#0F0F0F0F"
                      rounded="t-xl"
                    >
                      <v-text-field
                        v-model.trim="newItem"
                        :rules="rule"
                        :label="
                          $t(
                            'messanger.dash.filters.agents.agent_input_placeholder'
                          )
                        "
                        outlined
                        clearable
                        dense
                        color="cleed_blue"
                      />

                      <v-btn
                        class="mt-2"
                        outlined
                        :disabled="!valid"
                        :dark="valid"
                        type="submit"
                        color="cleed_blue"
                        dense
                      >
                        save <v-icon>mdi-check-bold</v-icon>
                      </v-btn>
                    </v-sheet>

                    <div class="pa-4">
                      <v-chip-group selected-class="text-primary" column>
                        <v-row
                          v-if="!agents || !agents.length"
                          no-gutters
                          justify="center"
                        >
                          <v-col cols="auto">
                            <span class="grey--text">No agents</span>
                          </v-col>
                        </v-row>
                        <v-chip
                          class="ma-1"
                          close
                          small
                          @click:close="removeItem(item)"
                          v-for="(item, i) in agents"
                          :key="i"
                        >
                          {{ item }}
                        </v-chip>
                      </v-chip-group>
                    </div>
                  </v-sheet>
                </v-form>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AddAgentBox",
  data() {
    return {
      panel_open: false,
      newItem: "",
      rule: [
        (v) =>
          (v && v.length <= 20) ||
          this.$t("messanger.dash.filters.agents.agent_input_errorMessage"),
      ],
      valid: false,
    };
  },
  computed: {
    agents() {
      const data = this.$store.state.admin.admin_details.agents;
      return data;
    },
  },
  methods: {
    saveItem() {
      if (this.agents.includes(this.newItem)) {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "the agent already exist",
          color: "warning",
        });
        return;
      }
      this.$store.dispatch("setLoader", {
        showing: true,
        text: "Saving ...",
      });
      this.$store
        .dispatch("UPDATE_ADMIN_AGENTS", { agent: this.newItem })
        .then(async (res) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: "Success",
            color: "success",
          });
          this.newItem = "";
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: err.data,
            color: "error",
          });
        })
        .finally((_) => {
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          this.newItem = "";
        });
    },
    removeItem(item) {
      console.log(item);
      if (!item) {
        return;
      }

      this.$store.dispatch("setLoader", {
        showing: true,
        text: "Saving ...",
      });
      this.$store
        .dispatch("DELETE_ADMIN_AGENT", item)
        .then(async (res) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: "Success",
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: err.data,
            color: "error",
          });
        })
        .finally((_) => {
          this.$store.dispatch("setLoader", {
            showing: false,
          });
        });
    },
  },
};
</script>
